export var ProfitSharingsFindOrdersBy = {
  creatorId: 'CREATOR_ID',
  modifierId: 'MODIFIER_ID',
  createdAt: 'CREATED_AT',
  status: 'STATUS',
  totalPrice: 'TOTAL_PRICE',
  updatedAt: 'UPDATED_AT'
};